import {AGREEMENT_CONFIRMINATION} from '../actions/agreement.actions';

export default function agreement(
  state = {
    join: false,
  },
  action
) {
  switch (action.type) {
    case AGREEMENT_CONFIRMINATION: {
      let nextState = {
        ...state,
      };
      nextState[action.agreementType] = true;
      return nextState;
    }
  }
  return state;
}
